module.exports = __webpack_public_path__ + "static/media/contactBGar.3931a2b2.png";